import { ActionOptions, BaseAction } from "../actions/base-actions";

export const RESET = "[Reset] Reset";
export const ENTITY = "";

export class ResetAction extends BaseAction {
    readonly entity = ENTITY;
    readonly type = RESET;

    constructor() {
        super(undefined, new ActionOptions({restful: false, persistable: false}));
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = ResetAction;



// WEBPACK FOOTER //
// ./src/core/store/reset-state/reset.actions.ts